<template>
    <el-dialog
            title="" class="messageNotice"
            :visible.sync="dialogVisible"
            width="680px" append-to-body
            :before-close="handleClose">
        <div class="flex flex-direction align-center justify-center text-df text-black">
            <div class="text-500 text-xl">请关注“Fotoo”公众号，及时接收活动消息</div>
            <div class="text-gray margin-top-sm">可接收活动进度、用户咨询、作品状态等消息通知</div>
            <div class="flex align-center justify-center">
                <div class="flex flex-direction align-center justify-center">
                    <div class="gongzhonghao"></div>
                    <div class="margin-top-xxl text-xl">请使用微信，关注公众号</div>
                </div>
                <div class="gongzhonghao-demo"></div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
  import App from '../../util/comfun'
  export default {
    props:{

    },
    data () {
      return {
        dialogVisible: false,
      }
    },
    components:{
    },
    methods:{
      handleClose(done) {
        done();
      },
      show(){
        this.dialogVisible=true
      },
    },
    mounted(){
        if(!App.cache('messageNotice')){
          App.cache('messageNotice','messageNotice')
          this.show()
        }
    },

  }
</script>

<style scoped="">
.messageNotice{
    .el-dialog{
        border-radius: 30px;
        padding-bottom: 40px;
    }
    .gongzhonghao{
        width: 213px;
        height: 213px;
        background-size: 100% 100%;
        background-image: url("https://assets.pfotoo.com/qrcode/gzh-258.jpg");
    }
    .gongzhonghao-demo{
        width: 148px;
        height: 297px;
        background-size: 100% 100%;
        background-image: url("https://assets.pfotoo.com/images/pc-help/%E7%BC%96%E7%BB%84%207@3x.png");
        margin-left: 116px;
        margin-top: 40px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/messageNotice.vue